exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container .card-img-art img[data-v-dbee1bb4]{width:50px}", ""]);

// exports
